import React, { useState } from 'react';
import { 
    Typography,
    Box,
    Container,
    styled,
    ImageList,
    ImageListItem,
} from '@mui/material';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import imgDetail1 from '../assets/crane1.jpg';
import imgDetail2 from '../assets/crane2.jpg';
import imgDetail3 from '../assets/crane3.jpg';
import imgDetail4 from '../assets/crane4.jpg';
import imgDetail5 from '../assets/crane5.jpg';

const Gallery = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const Section = styled(Box)(({ theme }) => ({
        padding: theme.spacing(10, 0),
        background: 'linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)',
    }));

    const SectionTitle = styled(Typography)(({ theme }) => ({
        fontFamily: "'Outfit', 'Roboto', sans-serif",
        fontWeight: 800,
        fontSize: 'clamp(2rem, 4vw, 3rem)',
        textAlign: 'center',
        marginBottom: theme.spacing(2),
        background: 'linear-gradient(135deg, #FF6B35 0%, #FF8C42 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
    }));

    const SectionSubtitle = styled(Typography)(({ theme }) => ({
        textAlign: 'center',
        color: '#64748b',
        fontSize: '1.1rem',
        marginBottom: theme.spacing(6),
        maxWidth: '800px',
        marginLeft: 'auto',
        marginRight: 'auto',
        lineHeight: 1.8,
    }));

    const CarouselWrapper = styled(Box)(({ theme }) => ({
        maxWidth: '900px',
        margin: '0 auto',
        borderRadius: '20px',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
        '& .carousel .slide': {
            background: 'transparent',
        },
        '& .carousel .slide img': {
            borderRadius: '20px',
            maxHeight: '600px',
            objectFit: 'cover',
        },
        '& .carousel .control-dots': {
            bottom: '20px',
            '& .dot': {
                background: 'rgba(255, 255, 255, 0.5)',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                width: '12px',
                height: '12px',
                '&.selected': {
                    background: '#FF6B35',
                },
            },
        },
        '& .carousel .thumbs-wrapper': {
            marginTop: theme.spacing(3),
            '& .thumb': {
                borderRadius: '8px',
                border: '3px solid transparent',
                transition: 'all 0.3s ease',
                '&.selected': {
                    border: '3px solid #FF6B35',
                },
                '&:hover': {
                    border: '3px solid #FF8C42',
                },
            },
        },
    }));

    const imageData = [
        {
            alt: 'Heavy-duty crane lifting construction materials in Coimbatore',
            url: imgDetail5,
            title: 'Heavy Lifting Operations',
        },
        {
            alt: 'Mobile crane service for industrial projects',
            url: imgDetail1,
            title: 'Mobile Crane Service',
        },
        {
            alt: 'Tower crane rental for high-rise construction',
            url: imgDetail2,
            title: 'Tower Crane Solutions',
        },
        {
            alt: 'Precision crane work for complex projects',
            url: imgDetail3,
            title: 'Precision Operations',
        },
        {
            alt: 'Professional crane operators at work site',
            url: imgDetail4,
            title: 'Expert Team in Action',
        },
    ];

    const renderSlides = imageData.map((image) => (
        <div key={image.alt}>
            <img src={image.url} alt={image.alt} loading="lazy" />
            <Box 
                sx={{ 
                    position: 'absolute',
                    bottom: 40,
                    left: 0,
                    right: 0,
                    textAlign: 'center',
                    color: '#fff',
                    background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%)',
                    padding: '40px 20px 20px',
                }}
            >
                <Typography 
                    variant="h5" 
                    sx={{ 
                        fontWeight: 700,
                        textShadow: '0 2px 10px rgba(0,0,0,0.5)',
                    }}
                >
                    {image.title}
                </Typography>
            </Box>
        </div>
    ));

    const handleChange = (index) => {
        setCurrentIndex(index);
    };

    return (
        <Section component="section">
            <Container maxWidth="lg">
                <SectionTitle variant="h2">
                    Work Gallery
                </SectionTitle>
                <SectionSubtitle>
                    Explore our Work Gallery to witness the quality and expertise that define our services. 
                    Each image tells a story of precision, dedication, and successful project completion. 
                    From intricate details to large-scale achievements, our gallery highlights the diverse 
                    range of projects we have undertaken.
                </SectionSubtitle>

                <CarouselWrapper>
                    <Carousel
                        showArrows={true}
                        autoPlay={true}
                        infiniteLoop={true}
                        interval={5000}
                        selectedItem={currentIndex}
                        onChange={handleChange}
                        showThumbs={true}
                        thumbWidth={120}
                        dynamicHeight={false}
                        emulateTouch={true}
                        swipeable={true}
                    >
                        {renderSlides}
                    </Carousel>
                </CarouselWrapper>
            </Container>
        </Section>
    );
};

export default Gallery;